import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';

export interface ModuleConfig {
    showIframe: boolean;
    enableToggle: boolean;
}

@Injectable({ providedIn: 'root' })
export class ModuleConfigService {
    private _config: Record<string, ModuleConfig> = {};

    constructor(private http: HttpClient) {}

    get config(): Record<string, ModuleConfig> {
        return this._config;
    }

    async load(): Promise<void> {
        this._config = await firstValueFrom(
            this.http.get<Record<string, ModuleConfig>>(
                'assets/module-config.json'
            )
        );
    }

    getConfig(moduleId: string): ModuleConfig | undefined {
        return this._config[moduleId];
    }
}
